import styled from "styled-components";

export const Trigger = styled.button<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  padding: 6px 11px;
  background: ${(p) =>
    p.$disabled ? "var(--color-bg-muted)" : "var(--color-bg-elevated)"};
  border: 1px solid var(--color-border);
  border-radius: 8px;
  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
  text-align: left;
  font-size: 14px;
  color: var(--color-text);
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    border-color: var(--color-primary);
  }

  &:focus-visible {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 2px rgba(216, 27, 96, 0.2);
    outline: none;
  }
`;

export const TriggerContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const TriggerCaret = styled.span`
  display: inline-flex;
  color: var(--color-text-tertiary);
  font-size: 12px;
  flex-shrink: 0;
`;

export const Placeholder = styled.span`
  color: var(--color-text-tertiary);
`;

export const SingleLabel = styled.span`
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectedChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  background: #FDF0F4;
  border: 1px solid #F6B3C7;
  color: #D81B60;
  border-radius: 4px;
  height: 28px;
  line-height: 26px;
  font-size: 14px;
  padding: 0 8px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SearchBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 12px 16px;
  background: var(--color-bg-elevated);
  border-bottom: 1px solid var(--color-border-light);
`;

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
  -webkit-overflow-scrolling: touch;
`;

export const Row = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  background: ${(p) =>
    p.$selected ? "var(--color-primary-light)" : "transparent"};
  border-bottom: 1px solid var(--color-border-light);
  transition: background 0.15s ease;

  &:hover {
    background: ${(p) =>
      p.$selected ? "var(--color-primary-lighter)" : "var(--color-bg-subtle)"};
  }
`;

export const RowLabel = styled.div`
  flex: 1;
  font-size: 15px;
  color: var(--color-text);
  line-height: 1.4;
  word-break: break-word;
`;

export const RowCheck = styled.div<{
  $selected: boolean;
  $shape: "box" | "circle";
}>`
  width: 24px;
  height: 24px;
  border-radius: ${(p) => (p.$shape === "circle" ? "50%" : "6px")};
  border: 1.5px solid
    ${(p) => (p.$selected ? "var(--color-primary)" : "var(--color-border)")};
  background: ${(p) =>
    p.$selected ? "var(--color-primary)" : "transparent"};
  color: var(--color-text-on-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
  transition: all 0.15s ease;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;

  .ant-btn {
    flex: 1;
    height: 40px;
    border-radius: 10px;
    font-weight: 500;
  }

  .ant-btn-primary {
    background: var(--color-gradient);
    border: none;

    &:hover,
    &:focus {
      background: var(--color-gradient-hover) !important;
    }
  }
`;

export const EmptyWrap = styled.div`
  padding: 32px 16px;
  display: flex;
  justify-content: center;
`;

export default {
  Trigger,
  TriggerContent,
  TriggerCaret,
  Placeholder,
  SingleLabel,
  SelectedChips,
  Chip,
  SearchBar,
  List,
  Row,
  RowLabel,
  RowCheck,
  Footer,
  EmptyWrap,
};
